
(function () {
  'use strict';

  function underscoresToCamelCase() {
      return function (value) {
        var formatted = '';
        var wasPreviousCharSeparator = true;
        for (var i = 0; i < value.length; i++) {
          var charVal = value.substring(i, i + 1);
          if (wasPreviousCharSeparator) {
            formatted = formatted + charVal.toUpperCase();
            wasPreviousCharSeparator = false;
          } else if (charVal === '_') {
            formatted = formatted + ' ';
            wasPreviousCharSeparator = true;
          } else {
            formatted = formatted + charVal;
            wasPreviousCharSeparator = false;
          }
        }
  
        return formatted;
      };
  }

  angular.module('ecap.common').filter('underscoresToCamelCase', underscoresToCamelCase);
})();